import React, { useCallback, useState } from 'react';
import { useBlockNavigation } from '@/hooks/useBlockNavigation';
import { UnsavedChangesModal } from '../UnsavedChangesModal';
import type { UnsavedChangesModalOptions } from '../UnsavedChangesModal/types';

interface ConfirmationModalWrapperProps {
  children: React.ReactNode;
  shouldBlock: boolean;
  modalProps: UnsavedChangesModalOptions;
}

export const ConfirmationModalWrapper = ({ children, shouldBlock, modalProps }: ConfirmationModalWrapperProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);

  const checkUnsavedChanges = useCallback(
    (actionOnDiscard: () => void): boolean => {
      if (shouldBlock) {
        setPendingAction(() => actionOnDiscard);
        setIsModalOpen(true);
        return false;
      } else {
        actionOnDiscard();
        return true;
      }
    },
    [shouldBlock]
  );

  const handleDiscardAndProceed = () => {
    setIsModalOpen(false);
    if (pendingAction) {
      pendingAction();
      setPendingAction(null);
    }
  };

  const handleCancelNavigation = () => {
    setIsModalOpen(false);
    setPendingAction(null);
  };

  useBlockNavigation(shouldBlock, checkUnsavedChanges);

  return (
    <>
      {children}
      <UnsavedChangesModal
        isOpen={isModalOpen}
        onClose={handleCancelNavigation}
        onSave={handleDiscardAndProceed}
        options={modalProps}
      />
    </>
  );
};
